var _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCheck = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--check",
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: svgRef
}, props), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "20 6 9 17 4 12"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconCheck.26a7adf2.svg";
export { ForwardRef as ReactComponent };